import { render, staticRenderFns } from "./helpcenter-faqs.vue?vue&type=template&id=6c1a3b9a&"
import script from "./helpcenter-faqs.vue?vue&type=script&lang=js&"
export * from "./helpcenter-faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports